let basePath = '/'

const parts = window.location.pathname.split('/')
if(parts[1] == 'en' || parts[1] == 'fr'){
  basePath = '/' + parts[1] + "/"
}
if(parts[1] == 'business' || parts[2] == 'business'){
  basePath = basePath == "/" ? "/business/app/" : '/' + parts[1] + "/business/app/"
}

export default basePath
